import { Box, Flex, Heading, Spacer, Tag, Text } from '@chakra-ui/react';
import { formatToCurrency } from '@common/utils/formatter';
import isNil from 'lodash/isNil';
import { numberFormatter } from '~/common/utils/formatter';
import { PremiumTag } from '../../../PremiumTag/PremiumTag';
import { ListingAgentInformation } from '../../../Storefront/ListingAgent/ListingAgentCard';
import { ListingPhotoCarousel } from '../../ListingPhotoCarousel/ListingPhotoCarousel';
import { useListingPageContext } from '../ListingPageContext';
import { getPropertyDetails } from '../utils';

export const PropertyInfo = () => {
  const {
    listing,
    propertyDetails,
    isViewOnly,
    isOffMarketListing,
    isMyListing,
  } = useListingPageContext();
  const {
    listPrice,
    photos,
    streetAddress,
    secondAddressLine,
    bedrooms,
    bathrooms,
    area,
    daysOnMarket,
  } = getPropertyDetails(listing, propertyDetails);

  return (
    <Box px={{ base: 0, md: 10 }} width="100%">
      {photos && <ListingPhotoCarousel images={photos} />}
      <Spacer h={photos ? 8 : 2} />
      {isOffMarketListing && !isViewOnly && (
        <Tag bg="white" color="indigo.900" lineHeight={1} textTransform="none">
          Off Market
        </Tag>
      )}
      {isMyListing && !isViewOnly && <PremiumTag label="My Listing" />}
      <Flex
        alignItems="center"
        direction="row"
        gap={2}
        justifyContent="space-between"
        pt={1}
      >
        <Flex alignItems="center" gap={4}>
          <Flex direction="column">
            <Heading as="h2" fontWeight="semibold">
              {formatToCurrency(listPrice)}
            </Heading>
            <Heading as="h4" fontWeight="semibold" p={0} size="xxs" zIndex={1}>
              {streetAddress ?? ''}
              <Text as="span" fontWeight="400" p={0} size="xxs" zIndex={1}>
                {secondAddressLine ? ` ${secondAddressLine}` : ''}
              </Text>
            </Heading>
            <Flex gap={8} mt={0}>
              <Text color="whiteAlpha.700" fontSize="md">
                {!isNil(bedrooms) && `${bedrooms} beds`}
                {!isNil(bedrooms) && !isNil(bathrooms) && ' • '}
                {!isNil(bathrooms) && `${bathrooms} baths`}
                {(!isNil(bedrooms) || !isNil(bathrooms)) &&
                  !isNil(area) &&
                  ' • '}
                {!isNil(area) &&
                  `${numberFormatter(area, { maxPrecision: 0 })} sqft`}
                {(!isNil(bedrooms) || !isNil(bathrooms) || !isNil(area)) &&
                  !isNil(daysOnMarket) &&
                  ' • '}
                {!isNil(daysOnMarket) && `${daysOnMarket} days on market`}
              </Text>
            </Flex>
          </Flex>
        </Flex>
        {listing && <ListingAgentInformation listing={listing} />}
      </Flex>
    </Box>
  );
};
